module.exports = __webpack_public_path__ + "static/img/lotte-aa-thumb.c73b7d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lotte-aa-thumb.jpg
// module id = OtVO
// module chunks = 0